/**
 * Personal-data processing consent policy version.
 *
 * Consent is versioned (decision "Согласие и retention данных PromoLanding"):
 * the client submits the accepted policy version; the *timestamp* and the rest
 * of the consent evidence (source IP, user agent, text hash) are recorded
 * server-side and are never derived on the client.
 *
 * NOTE (pending legal): the authoritative policy text and its final version id
 * are confirmed by legal (see the linked open question in the decision). This
 * constant is the working MVP baseline and must be bumped whenever the consent
 * text changes so previously accepted versions remain distinguishable.
 */
export const consentPolicyVersion = 'mvp-2026-07-20';
